import { put, call, select } from 'redux-saga/effects';
import { Types } from './actions';
import KnowledgeBaseDataRepository from '../../../../data/repositories/KnowledgeBaseRepository';
import KnowledgeBaseRepository from '../../../repositories/KnowledgeBaseRepository';
import TextHelper from '../../../../core/helpers/TextHelper';

export default function* saga(action: any): any {
  try {
    const { categoryCode, subCategoryCode } = action;
    yield put({ type: Types.GET_ARTICLES_REQUEST });
    const knowledgeBaseRepository: KnowledgeBaseRepository =
      new KnowledgeBaseDataRepository();
    const { data } = yield select((state) => state.profile);
    const articlesResponse = yield call(
      knowledgeBaseRepository.getArticlesByCategory,
      categoryCode,
      subCategoryCode,
      !!data
    );
    if (!articlesResponse) {
      yield put({
        type: Types.GET_ARTICLES_FAILURE,
        error: true
      });
      return;
    }
    articlesResponse.sort(TextHelper.sortByName);
    yield put({
      type: Types.GET_ARTICLES_SUCCESS,
      data: articlesResponse
    });
  } catch (error: any) {
    yield put({
      type: Types.GET_ARTICLES_FAILURE,
      error: error.message
    });
  }
}
